import styled from 'styled-components';

export const IconButton = styled.button`
  display: flex;
  padding: 0;
  width: 27px;
  height: 27px;
  border: 1px solid ${({ theme }) => theme.customColors.primary};
  border-radius: 100%;
  outline: none;
  background: #ffffff;

  & > svg {
    color: ${({ theme }) => theme.customColors.primary};
  }

  &:hover {
    cursor: pointer;
  }

  &:disabled {
    opacity: 0.5;
    cursor: normal;
  }
`;
